// extracted by mini-css-extract-plugin
export var bodySections = "_ad-8";
export var gray = "_ad-7";
export var green = "_ad-4";
export var iconContainer = "_ad-9";
export var iconWidgetContainer = "_ad-1";
export var phoneIcon = "_ad-2";
export var red = "_ad-5";
export var statusDot = "_ad-3";
export var widgetContainer = "_ad-0";
export var yellow = "_ad-6";